import { WARRANTY_CANCELLATION_API_URL } from "../components/Shared/constant";

const WarrantyCancellationAPI = async (accessToken, payload) => {
  try {
    const result = await window.axios.post(
      WARRANTY_CANCELLATION_API_URL,
      {
        purchase_id: payload.purchase_id,
        remark: payload.remark,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return {
      ...result.data,
      status: result.status,
      success: true,
    };
  } catch (error) {
    return {
      ...(error?.response?.data || { message: "Something went wrong" }),
      status: error?.response?.status || 500,
      success: false,
    };
  }
};

export default WarrantyCancellationAPI;
